var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 20C15 20.8284 14.3284 21.5 13.5 21.5C12.6716 21.5 12 20.8284 12 20C12 19.1716 12.6716 18.5 13.5 18.5C14.3284 18.5 15 19.1716 15 20ZM21 20C21 20.8284 20.3284 21.5 19.5 21.5C18.6716 21.5 18 20.8284 18 20C18 19.1716 18.6716 18.5 19.5 18.5C20.3284 18.5 21 19.1716 21 20ZM25.5 21.5C26.3284 21.5 27 20.8284 27 20C27 19.1716 26.3284 18.5 25.5 18.5C24.6716 18.5 24 19.1716 24 20C24 20.8284 24.6716 21.5 25.5 21.5Z",
    fill: "#B6BAC6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActions);
export default __webpack_public_path__ + "static/media/Actions.b42631d3b68b20e5fb77178add9974b3.svg";
export { ForwardRef as ReactComponent };